
import useCart from '@/composables/useCart'
import { defineComponent } from 'vue'
import PromoCodeWidget from './PromoCodeWidget.vue'
import CartDiscountsWidget from './CartDiscountsWidget.vue'

export default defineComponent({
  components: { PromoCodeWidget, CartDiscountsWidget },

  setup() {
    const { items, total, incrementItem, decrementItem, removeItem } = useCart()

    const checkout = () => {
      alert('Please purchase the "Checkout" DLC to checkout your products!')
    }

    return { items, total, incrementItem, decrementItem, removeItem, checkout }
  },
})
